import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SenderWalletListState,
  SENDER_WALLET_LIST_STATE,
} from './sender-wallet-list.state';

export const selectSenderWallet = createFeatureSelector<SenderWalletListState>(
  SENDER_WALLET_LIST_STATE
);

export const selectSenderWalletList = createSelector(
  selectSenderWallet,
  (state: SenderWalletListState) => {
    return state.dataSource;
  }
);

export const selectSenderWalletListFilter = createSelector(
  selectSenderWallet,
  (state: SenderWalletListState) => state.filter
);
